export enum ContactValue {
    NAME = "NAME",
    EMAIL = "EMAIL"
}